module.exports = __webpack_public_path__ + "img/39_22.c3aefbc3.png";